import { type VaultMediaItemDto, VaultMediaType } from '@api'
import { format, isSameYear } from 'date-fns'

import VaultAudioIcon from '@/assets/icons/icon-vault-audio.svg'
import VaultGifIcon from '@/assets/icons/icon-vault-gif.svg'
import VaultImageIcon from '@/assets/icons/icon-vault-image.svg'
import VaultVideoIcon from '@/assets/icons/icon-vault-video.svg'
import { secondsToTime } from '@/modules/chatting/ui/utils.ts'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  label?: string
  price?: number
  date: Date | null
  item: VaultMediaItemDto
  showBackground?: boolean
}

const getVaultIcon = (itemType: VaultMediaType) => {
  if (itemType === VaultMediaType.VIDEO) {
    return <VaultVideoIcon />
  }

  if (itemType === VaultMediaType.AUDIO) {
    return <VaultAudioIcon />
  }

  if (itemType === VaultMediaType.GIF) {
    return <VaultGifIcon />
  }

  return <VaultImageIcon />
}

export const VaultMediaItemFooter = ({
  label,
  price,
  date,
  item,
  showBackground,
}: Props) => {
  const displayDate =
    date &&
    format(date, isSameYear(date, new Date()) ? 'MMM dd' : 'MMM dd, yyyy')

  return (
    <div
      className={classNames(
        'absolute bottom-0 left-0 z-[10] flex w-full flex-col gap-1 px-2 py-2',
        { 'bg-secondary-900/70': showBackground },
      )}
    >
      <div className="flex w-full items-center justify-between">
        {label ? (
          <p
            title={label}
            className={classNames(
              'overflow-hidden overflow-ellipsis whitespace-nowrap text-xs font-medium',
              {
                'text-secondary-200': showBackground,
              },
            )}
          >
            {label}
          </p>
        ) : (
          // To show price on the right with justify-between
          <p />
        )}

        <div>${price}</div>
      </div>
      <div className="text-secondary-300 flex items-center gap-1.5 text-xs">
        <div className="whitespace-nowrap">{displayDate}</div>
        {' | '}
        {getVaultIcon(item.type)}
        {!!item.duration && (
          <span className="text-xs font-medium">
            {secondsToTime(Math.floor(item.duration))}
          </span>
        )}
      </div>
    </div>
  )
}
